import axios from "axios";
import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { environment } from "../../environment";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import "./LeadExecutive/leadexecutive.css";
import NavbarNew from "../Components/NavbarNew";
import { update } from "lodash";

const MySwal = withReactContent(Swal);

const PartnerEditProfile = ({ history, match }) => {
  const [name, setname] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [role, setrole] = useState({});
  const [roleCount, setRoleCount] = useState({});
  const [email, setmail] = useState("");
  const [phone, setphone] = useState("");
  const [dob, setdob] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [countrycode, setCountryCode] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [zip, setzip] = useState("");
  const [address, setAddress] = useState("");
  const [pwd, setpassword] = useState("");
  const [nameErrors, setNameErrors] = useState({});
  const [fnameErrors, setFNameErrors] = useState({});
  const [lnameErrors, setLNameErrors] = useState({});
  const [roleErrors, setroleErrors] = useState({});
  const [emailErrors, setemailErrors] = useState({});
  const [passwordErrors, setpasswordErrors] = useState({});
  const [organizationErrors, setOrganizationErrors] = useState({});
  const [phoneErrors, setphoneErrors] = useState({});
  const [organization, setOrganization] = useState("");
  const [id, setId] = useState("");
  const [showOrganization, setShowOrganization] = useState("none");
  let roles = [];
  roles = [
    {
      role: "Partner",
      role_value: "partner",
    },
  ];
  let countries = [];
  countries = Country.getAllCountries();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };
  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };
  const formValidation = () => {
    let isValid = true;
    const fnameErrors = {};
    const lnameErrors = {};
    const roleErrors = {};
    const emailErrors = {};
    const organizationErrors={};
   
    const phoneErrors = {};
    setNameErrors("");
    setroleErrors("");
    setemailErrors("");
    setroleErrors("");
    setphoneErrors("");
    setOrganizationErrors("");

    if (fname == "") {
      fnameErrors.noName = "First name is required";
      isValid = false;
      setFNameErrors(fnameErrors);
    }
    if (lname == "") {
      lnameErrors.noName = "Last name is required";
      isValid = false;
      setLNameErrors(lnameErrors);
    }
    console.log(nameErrors);
    if (email == "") {
      emailErrors.noName = "Email is required";
      isValid = false;
      setemailErrors(emailErrors);
    }
    if (email == "") {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    }
    if (phone != "") {
      var phoneno = /^\d{10}$/;
      if (!phone.match(phoneno)) {
        phoneErrors.noName = "Provide a Proper Phone No.";
        isValid = false;
        setphoneErrors(phoneErrors);
      }
    }

     if (organization == "") {
      organizationErrors.noOrg = "Organization is required";
      isValid = false;
      setOrganizationErrors(organizationErrors);
      console.log(isValid);
    }
    console.log(isValid);
    return isValid;
  };

  const Update = () => {
    console.log("clicked");
    let validform = formValidation();
    console.log(validform);
    let user = JSON.parse(localStorage.getItem("userDetails"));
    user.data.firstName = fname;
    user.data.lastName = lname;
    if (validform) {
      setFNameErrors({});
      setLNameErrors({});
      axios.post(environment.dap_url + "users/updateUser", {
          id: id,
          userFirstName: fname,
          userLastName: lname,
          organization: organization,
          city: postcity,
          state: poststate,
          country: postcountry,
          zip: zip,
          address: address,
          phone: phone,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.error) {
            MySwal.fire({
              title: <p>Given Mail id already exist</p>,
              type: "success",
            });
          } else {
            MySwal.fire({
              title: <p>User Updated</p>,
              type: "success",
            });
            localStorage.removeItem("userDetails");
            localStorage.setItem("userDetails", JSON.stringify(user));
            // window.location.reload();
            // getUserData(JSON.parse(localStorage.getItem("userDetails")));
          }
        })
        .catch((err) => {
          console.log(err);
          MySwal.fire({
            title: <p>{err?.response?.data?.message}</p>,
            type: "error",
          });
        });
    }
  };
  const setrole1 = (e) => {
    console.log(e.value);
    roles.forEach((utype) => {
      if (utype.role_value == e.value) {
        console.log("hii");
        setrole({ label: utype.role[0], value: utype.role_value });
      }
    });
    // setrole(dtype);
  };
  useEffect(() => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    getUserData(userDetails);
    update();
  }, []);

  const getUserData = (userDetails) => {
    console.log("userDetails", userDetails);
    axios
      .post(environment.dap_url + "users/getUsersByMail", {
        email: userDetails.data.email,
      })
      .then((res) => {
        console.log("response", res);
        setId(res.data._id);
        setname(res.data.userFirstName);
        setFname(res.data.userFirstName);
        setOrganization(res.data.organization);
        setLname(res.data.userLastName);
        setmail(res.data.email);
        setphone(res.data.phone);
        setdob(res.data.DOB);
        setzip(res.data.zip);
        setAddress(res.data.address);
        setPostCountry(res.data.country);
        setPostState(res.data.state);
        setPostCity(res.data.city);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />

        <h4 className="text-center">Manage Profile</h4>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="consignee">
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setmail(e.target.value)}
                  readOnly
                ></Form.Control>
                <div>
                  {Object.keys(emailErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{emailErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group controlId="consignee">
                <Form.Label>Role*</Form.Label>
                <Select
                  options={[
                    {
                      value: roles[0].role_value,
                      label: roles[0].role,
                    },
                  ]}
                  value={{
                    value: roles[0].role_value,
                    label: roles[0].role,
                  }}
                  onChange={(e) => setrole1(e)}
                  placeholder="Role"
                />
                <div>
                  {Object.keys(roleErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{roleErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="row" >
            <div className="col">
              <Form.Group controlId="consignee">
                <Form.Label>Organization*</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Organization name"
                    required
                    value={organization}
                    onChange={(e) => setOrganization(e.target.value)}
                  ></Form.Control>
                <div>
                      {Object.keys(organizationErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>
                            {organizationErrors[key]}
                          </div>
                        );
                      })}
                    </div>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Form.Group controlId="consignee">
                <Form.Label>First Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  required
                  value={fname}
                  onChange={(e) => setFname(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(fnameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{fnameErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group controlId="consignee">
                <Form.Label>Last Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  required
                  value={lname}
                  onChange={(e) => setLname(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(lnameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{lnameErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Form.Group controlId="consignee">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Phone"
                  value={phone}
                  onChange={(e) => setphone(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(phoneErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{phoneErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Form.Group controlId="countri">
                <Form.Label>Country</Form.Label>
                <Select
                  options={countries.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  value={{
                    label: postcountry,
                    value: postcountry,
                  }}
                  onChange={(e) => selectCountry(e)}
                  placeholder="Country"
                />
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="name">
                <Form.Label>State</Form.Label>
                <Select
                  options={dap_states.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  value={{
                    label: poststate,
                    value: poststate,
                  }}
                  onChange={(e) => selectRegion(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="State"
                />
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="name">
                <Form.Label>City</Form.Label>
                <Select
                  options={dap_city.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectCity(e)}
                  value={{ label: postcity, value: postcity }}
                  defaultValue="hi there"
                  placeholder="City"
                />
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Form.Group controlId="consignee">
                <Form.Label>Zip</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Zip"
                  value={zip}
                  onChange={(e) => setzip(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group controlId="consignee">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Button
                variant="primary"
                style={{ marginTop: 22 }}
                onClick={Update}
              >
                SAVE
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnerEditProfile;
